import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListReviewerPerformanceRecentV2Query } from './list-reviewer-performance-recent-v2-request';
import type { IListReviewerPerformanceRecentV2Response } from './list-reviewer-performance-recent-v2-response';
import { listReviewerPerformanceRecentV2ResponseSchema } from './list-reviewer-performance-recent-v2-response';

export async function listReviewerPerformanceRecentV2Api(
  query: IListReviewerPerformanceRecentV2Query,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IListReviewerPerformanceRecentV2Response>> {
  const params = new URLSearchParams();
  params.set('userId', query.userId);
  if (query.limit != null) {
    params.set('limit', String(query.limit));
  }
  if (query.offset != null) {
    params.set('offset', String(query.offset));
  }
  return getRequest<IListReviewerPerformanceRecentV2Response>({
    path: `/sys/reviewer-performance/v2/recent?${params.toString()}`,
    schema: listReviewerPerformanceRecentV2ResponseSchema,
    options,
  });
}
